import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {
  ColumnApi,
  GetContextMenuItemsParams,
  GridApi,
  GridReadyEvent,
  IServerSideGetRowsParams
} from 'ag-grid-community';
import {environment} from '../../../../environments/environment';
import {HttpService} from '../../../services/http.service';

@Component({
  selector: 'app-ai-report-dialog',
  templateUrl: './ai-report-dialog.component.html',
  styleUrls: ['./ai-report-dialog.component.scss']
})
export class AiReportDialogComponent implements OnInit {
  public gridApi?: GridApi;
  public columnApi?: ColumnApi;

  public defaultColDef = {
    resizable: true,
    flex: 1,
    minWidth: 120,
    editable: false,
    enableRowGroup: false,
    suppressColumnsToolPanel: true
  };

  public columnDefs = [
    {
      field: '_id',
      hide: true,
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
    },
    {
      field: 'product_id',
      headerName: 'product_id',
      maxWidth: 150,
      hide: true,
    },
    {
      field: 'handle',
      headerName: 'handle',
      maxWidth: 150,
      hide: true,
    },
    {
      field: 'sku',
      headerName: 'sku',
      maxWidth: 150
    },
    {
      field: 'previous_structure',
      headerName: 'previous_structure',
      minWidth: 440
    },
    {
      field: 'updated_structure',
      headerName: 'updated_structure',
      minWidth: 640
    },
  ];

  getGptContextMenuItems = (params: GetContextMenuItemsParams) => {
    return [
      {
        name: 'Open Shopify page',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://blackhawksupply.com/products/' + params?.node?.data.handle, '_blank');
        }
      },
      'separator',
      'export',
    ];
  }

  public rowData: any = [];
  constructor(
    private dialogRef: MatDialogRef<AiReportDialogComponent>,
    private httpService: HttpService,
  ) { }

  ngOnInit(): void {
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    const that = this;

    this.gridApi.setServerSideDatasource({
      getRows(params: IServerSideGetRowsParams) {
        that.httpService.get(environment.API_PATH + '/ai/getLastGptUpdateReport').subscribe((dataAndCount) => {
          const receivedData = dataAndCount as { rows: {}[], count: number };
          params.success({
            rowData: receivedData.rows,
            rowCount: receivedData.count
          });
        });
      }
    });
  }
  close(): void {
    this.dialogRef.close();
  }
}
